(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "immutable", "immutablediff", "prop-types", "react", "react-immutable-proptypes", "./BaseField"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("immutable"), require("immutablediff"), require("prop-types"), require("react"), require("react-immutable-proptypes"), require("./BaseField"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.immutable, global.immutablediff, global.propTypes, global.react, global.reactImmutableProptypes, global.BaseField);
    global.Form = mod.exports;
  }
})(this, function (_exports, _immutable, _immutablediff, _propTypes, _react, _reactImmutableProptypes, _BaseField) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports["default"] = void 0;
  _immutable = _interopRequireWildcard(_immutable);
  _immutablediff = _interopRequireDefault(_immutablediff);
  _propTypes = _interopRequireDefault(_propTypes);
  _react = _interopRequireDefault(_react);
  _reactImmutableProptypes = _interopRequireDefault(_reactImmutableProptypes);
  _BaseField = _interopRequireDefault(_BaseField);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

  function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

  function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

  function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

  function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

  function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

  function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

  function _toArray(arr) { return _arrayWithHoles(arr) || _iterableToArray(arr) || _nonIterableRest(); }

  function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

  function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

  function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

  function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

  function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

  function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

  function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

  function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

  function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

  function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

  function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

  function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

  // Creates a debounced version of `func` that receives its arguments as first,
  // and a callback function as second argument. When invoked multiple times, the
  // callback function is only called for the last invocation of `func`.
  function createValidateFunc(func) {
    var waitMs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var timer = null;
    var lastPendingId = 0;

    function run(args, doneFunc) {
      var currentPendingId = lastPendingId + 1;
      var result = func.apply(void 0, _toConsumableArray(args));
      lastPendingId = currentPendingId;
      timer = null;

      if (result && typeof result.then === 'function') {
        result.then(function () {
          if (lastPendingId === currentPendingId) {
            doneFunc.apply(void 0, arguments);
          }
        });
      } else {
        doneFunc(result);
      }
    }

    return function (args, doneFunc) {
      var runImmediately = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      if (timer) window.clearTimeout(timer);

      if (waitMs === null || runImmediately) {
        run(args, doneFunc);
      } else {
        timer = window.setTimeout(function () {
          return run(args, doneFunc);
        }, waitMs);
      }
    };
  }

  function containsError(errors) {
    if (!errors) {
      return false;
    } else if (_immutable["default"].Iterable.isIterable(errors)) {
      return errors.reduce(function (res, item) {
        if (res) {
          return true;
        } else if (!item) {
          return false;
        } else if (typeof item === 'string') {
          return true;
        } else {
          return containsError(item);
        }
      }, false);
    } else {
      throw new Error();
    }
  }

  function parseName(name) {
    // only split string names by dots, but keep non string names (for example number names
    // like in IteratorField) as they are
    return typeof name === 'string' ? name.split(/\./g) : [name];
  }

  var FormValueScopeContext = _BaseField["default"].contextType; // kind of inherits from FormValueScope
  // make sure to mirror changes in FormValueScope here

  var Form =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(Form, _React$Component);

    _createClass(Form, [{
      key: "name",
      get: function get() {
        return this.props.name;
      }
    }]);

    function Form(props) {
      var _this;

      _classCallCheck(this, Form);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(Form).call(this, props));

      _defineProperty(_assertThisInitialized(_this), "updatedExternalErrors", false);

      _defineProperty(_assertThisInitialized(_this), "getValue", function (name) {
        if (name !== undefined && name !== null) {
          return _this.state.value.getIn(parseName(name));
        } else {
          return _this.state.value;
        }
      });

      _defineProperty(_assertThisInitialized(_this), "handleUnmappedServerErrors", function (serverErrors) {
        if (serverErrors && serverErrors.errors && serverErrors.errors.size > 0) {
          var formFieldsStructure = _this.getFormFieldsStructure();

          var _serverErrors$errors$ = serverErrors.errors.keys(),
              _serverErrors$errors$2 = _toArray(_serverErrors$errors$),
              serverErrorKeys = _serverErrors$errors$2.slice(0); // we getting only first one


          var unmappedErrorKey = serverErrorKeys.find(function (el) {
            return !formFieldsStructure.includes(el);
          });

          if (unmappedErrorKey) {
            var unmappedOutputObject = {
              field: unmappedErrorKey,
              message: serverErrors.errors.get(unmappedErrorKey)
            };

            _this.props.handleUnmappedErrors(unmappedOutputObject);
          }
        }
      });

      _defineProperty(_assertThisInitialized(_this), "getFormValuesFirstDifference", function (currentValue, newValue) {
        var differences = (0, _immutablediff["default"])(currentValue, newValue);
        var replaceOperation = 'replace';

        if (differences) {
          var firstDifference = differences.filter(function (entry) {
            return entry.get('op') === replaceOperation;
          }).first();

          if (firstDifference && firstDifference.size > 0) {
            return firstDifference.get('path').split('/').filter(Boolean);
          }
        }
      });

      _defineProperty(_assertThisInitialized(_this), "getChangedCompleteErrorList", function (currentValue, newValue, serverErrors) {
        var path = _this.getFormValuesFirstDifference(currentValue, newValue);

        if (path && serverErrors.hasIn(path)) {
          return serverErrors.setIn(path, false);
        }

        return serverErrors;
      });

      _defineProperty(_assertThisInitialized(_this), "setValue", function (name, value) {
        var newValue1 = name !== undefined && name !== null ? _this.state.value.setIn(parseName(name), value) : value;

        var newValue2 = _this.props.onChange(newValue1);

        var newValue = newValue2 || newValue1;
        var externalErrors = _this.updatedExternalErrors || _this.props.externalErrors; // because only one field value could be change at the time

        var updatedErrorList = externalErrors && externalErrors.size > 0 && _this.getChangedCompleteErrorList(_this.state.value, newValue, externalErrors);

        _this.setState({
          value: newValue
        });

        _this.validate([newValue, _this.state.triedToSubmit, name], function (validationResult) {
          // in case we have errors in server and client at the same time we merging it
          if (updatedErrorList && updatedErrorList.size > 0) {
            validationResult = validationResult ? validationResult.mergeDeepWith(function (oldVal, newVal) {
              return oldVal && oldVal !== false ? oldVal : newVal;
            }, updatedErrorList) : updatedErrorList;
          }

          _this.updatedExternalErrors = updatedErrorList;
          var hasErrors = containsError(validationResult);

          if (hasErrors) {
            _this.props.onError(validationResult, false);
          }

          _this.setState({
            errors: hasErrors ? validationResult : new _immutable["default"].Map()
          });
        });
      });

      _defineProperty(_assertThisInitialized(_this), "reset", function () {
        _this.setState({
          value: _this.props.prepare(_this.props.value),
          errors: new _immutable["default"].Map(),
          triedToSubmit: false,
          pristine: true,
          submitting: false
        });
      });

      _defineProperty(_assertThisInitialized(_this), "getFormFieldsStructure", function () {
        if (_this.props.value && _this.props.value.size > 0) {
          return _toConsumableArray(_this.props.value.keys());
        }
      });

      _defineProperty(_assertThisInitialized(_this), "getError", function (name) {
        return _this.state.errors.getIn(parseName(name));
      });

      _defineProperty(_assertThisInitialized(_this), "submit", function () {
        return _this.handleSubmit({
          preventDefault: function preventDefault() {}
        });
      });

      _defineProperty(_assertThisInitialized(_this), "handleSubmit", function (event) {
        event.preventDefault();

        if (!_this.props.disabled && !_this.state.submitting) {
          _this.validate([_this.state.value, true, null], function (validationResult) {
            if (containsError(validationResult)) {
              _this.props.onError(validationResult, true);

              _this.setState({
                errors: validationResult,
                triedToSubmit: true
              });
            } else {
              _this.setState({
                errors: new _immutable["default"].Map()
              });

              var result = _this.props.onSubmit(_this.props.normalize(_this.state.value));

              if (result && typeof result.then === 'function') {
                _this.setState({
                  submitting: true
                });

                result["catch"](function () {}).then(function () {
                  return _this.willUnmount || _this.setState({
                    submitting: false
                  });
                });
              }
            }

            _this.updatedExternalErrors = false;
          }, true);
        }
      });

      _this.state = {
        value: props.prepare(props.value),
        errors: new _immutable["default"].Map(),
        triedToSubmit: false,
        pristine: true,
        submitting: false
      };
      _this.validate = createValidateFunc(props.validate, props.validateWaitMs);
      return _this;
    } // eslint-disable-next-line camelcase


    _createClass(Form, [{
      key: "UNSAFE_componentWillReceiveProps",
      value: function UNSAFE_componentWillReceiveProps(nextProps) {
        var _this2 = this;

        var serverErrors = nextProps.externalErrors && nextProps.externalErrors.size > 0 ? {
          errors: nextProps.externalErrors
        } : null;

        if (!(0, _immutable.is)(this.props.value, nextProps.value)) {
          this.setState({
            value: nextProps.prepare(nextProps.value),
            errors: serverErrors && serverErrors.errors || new _immutable["default"].Map(),
            triedToSubmit: false,
            pristine: true,
            submitting: false
          }, function () {
            _this2.handleUnmappedServerErrors(serverErrors);

            _this2.props.onError(nextProps.externalErrors, true);
          });
        } else {
          this.setState(serverErrors, function () {
            _this2.handleUnmappedServerErrors(serverErrors);

            _this2.props.onError(nextProps.externalErrors, true);
          });
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.willUnmount = true;
      }
    }, {
      key: "render",
      value: function render() {
        var _this3 = this;

        var _this$props = this.props,
            name = _this$props.name,
            value = _this$props.value,
            onSubmit = _this$props.onSubmit,
            onChange = _this$props.onChange,
            prepare = _this$props.prepare,
            validate = _this$props.validate,
            validateWaitMs = _this$props.validateWaitMs,
            normalize = _this$props.normalize,
            disabled = _this$props.disabled,
            children = _this$props.children,
            externalErrors = _this$props.externalErrors,
            handleUnmappedErrors = _this$props.handleUnmappedErrors,
            onError = _this$props.onError,
            other = _objectWithoutProperties(_this$props, ["name", "value", "onSubmit", "onChange", "prepare", "validate", "validateWaitMs", "normalize", "disabled", "children", "externalErrors", "handleUnmappedErrors", "onError"]);

        return _react["default"].createElement(FormValueScopeContext.Provider, {
          value: {
            instance: this,
            state: this.state
          }
        }, _react["default"].createElement("form", _extends({
          autoComplete: "off"
        }, other, {
          name: name,
          onSubmit: this.handleSubmit
        }), typeof children === 'function' ? children({
          value: this.state.value,
          pristine: _immutable["default"].is(value, this.state.value),
          submitting: this.state.submitting,
          reset: function reset() {
            return _this3.reset();
          }
        }) : children));
      }
    }]);

    return Form;
  }(_react["default"].Component);

  _exports["default"] = Form;

  _defineProperty(Form, "propTypes", {
    name: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired,
    value: _propTypes["default"].any,
    onSubmit: _propTypes["default"].func,
    onChange: _propTypes["default"].func,
    prepare: _propTypes["default"].func,
    validate: _propTypes["default"].func,
    validateWaitMs: _propTypes["default"].number,
    normalize: _propTypes["default"].func,
    disabled: _propTypes["default"].bool,
    children: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].func]).isRequired,
    externalErrors: _reactImmutableProptypes["default"].map,
    handleUnmappedErrors: _propTypes["default"].func,
    onError: _propTypes["default"].func
  });

  _defineProperty(Form, "defaultProps", {
    value: new _immutable["default"].Map(),
    onSubmit: function onSubmit() {
      return null;
    },
    onChange: function onChange() {
      return null;
    },
    prepare: function prepare(value) {
      return value;
    },
    validate: function validate() {
      return null;
    },
    validateWaitMs: null,
    normalize: function normalize(value) {
      return value;
    },
    disabled: false,
    externalErrors: null,
    handleUnmappedErrors: function handleUnmappedErrors() {
      return null;
    },
    onError: function onError() {
      return null;
    }
  });
});